export default __webpack_public_path__ + "static/media/ProductsList_img1_Cn.894ea788.webp";